import React from "react"

import apiConfig from "../../apiConfig"
import { makeApiCall } from "../../utils/gatewayUtils"
import { shuffleArray } from "../../utils/misc"
import TeamCard from "../template-parts/product-marketing/TeamCard"
import GridToSwipeable from "../template-parts/product-marketing/GridToSwipeable"
import Section from "../template-parts/product-marketing/Section"
import Loading from "../template-parts/Loading"
import { Instructor } from "../../types"

type Props = {
  head?: string
  doLimit?: boolean
  location?: string | null
  state?: string | null
  doAlwaysShow?: boolean
  doWrapWithSection?: boolean
}

const MeetInstructors = ({
  doLimit = true,
  head = "Meet Some of Our Certified Instructors",
  location,
  state,
  doAlwaysShow = false,
  doWrapWithSection = true,
}: Props) => {
  const [instructors, setInstructors] = React.useState<null | Instructor[]>(
    null,
  )

  React.useEffect(() => {
    const abortController = new window.AbortController()
    const { signal } = abortController

    makeApiCall(
      `${apiConfig.instructors}?doLimit=${doLimit}&location=${location}&state=${state}`,
      { method: "GET", signal },
    )
      .then((res) => {
        if (!res) {
          setInstructors([])
        }
        setInstructors(shuffleArray(res.instructors))
      })
      .catch(() => {
        setInstructors([])
      })
    return () => {
      abortController.abort()
    }
  }, [doLimit, location, state])

  if (!instructors) return <Loading />

  if (instructors.length < 4 && !doAlwaysShow) {
    // Only show instructors if there are 4 or more.
    return null
  }

  const renderContent = () => (
    <GridToSwipeable
      data-cy="team-swipable"
      items={instructors.map((instructor) => (
        <TeamCard
          key={instructor.id}
          instructorId={instructor.id}
          image={instructor.portraitImage}
          name={`${instructor.displayName || instructor.firstName}`}
          text={instructor.summary}
          link={`/instructor/${instructor.id}`}
        />
      ))}
    />
  )

  if (!doWrapWithSection) return renderContent()

  return (
    <Section
      head={head}
      subhead="Our friendly, professional instructors bring a wide range of experiences to teaching you to drive. Each instructor is certified by the state and has completed an intensive training course. We're one of the only driving schools to do independent background and drug screens."
    >
      {renderContent()}
    </Section>
  )
}

export default MeetInstructors
